import { Subject } from 'rxjs';

import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { FsMap } from '@lib/geo/map';

import { AppliancesMapService } from '../../services/appliances-map.service';

@Component({
  selector: 'fs-appliance-map-maximizer-dialog',
  templateUrl: './appliance-map-maximizer-dialog.component.html',
  styleUrls: ['./appliance-map-maximizer-dialog.component.scss'],
})
export class ApplianceMapMaximizerDialogComponent implements OnInit, OnDestroy {
  private maximizedMap: FsMap;
  public address: string;
  private readonly _destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<ApplianceMapMaximizerDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      coordinates: number[];
      style: string;
      zoom: number;
      address: string;
    },
    private mapUtility: AppliancesMapService,
  ) {}

  ngOnInit(): void {
    this.address = this.data.address;
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  onMapInit(map: FsMap): void {
    this.maximizedMap = map;

    if (this.data.coordinates) {
      this.mapUtility.setupMap(
        map,
        this.data.style,
        this.data.coordinates,
        this.data.zoom + 1, // Zoom in by 1 level for better visibility
      );
      this.mapUtility.createMarker(map, this.data.coordinates);
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
